module.exports = __webpack_public_path__ + "img/error.a83ce8a9.svg";